import { useCallback, useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Toaster, toast } from "sonner";
import { Link } from "react-router-dom";
import { api } from "../../lib/apiClient";
import { Paginated } from "./ContactsManager";

export default function ContactsTreated() {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);

    const fetchAll = useCallback(async () => {
        try {
            const { data } = await api.get("/admin/contacts");
            const traites = data.filter((m) => (m.status || (m.handled ? "traite" : "nouveau")) === "traite");
            setItems(traites);
        } catch (_e) {
            toast.error("Erreur de chargement");
        }
    }, []);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    const setStatus = async (id, status) => {
        try {
            await api.put(`/admin/contacts/${id}/status`, { status });
            toast.success("Réouvert");
            fetchAll();
        } catch (_e) {
            toast.error("Erreur");
        }
    };

    const remove = async (id) => {
        if (!window.confirm("Supprimer définitivement ?")) return;
        try {
            await api.delete(`/admin/contacts/${id}`);
            toast.success("Supprimé");
            fetchAll();
        } catch (_e) {
            toast.error("Erreur");
        }
    };

    return (
        <div data-testid="admin-contacts-traites-page">
            <Toaster richColors position="top-center" />
            <Link
                to="/admin/contacts"
                className="inline-flex items-center gap-2 text-sm text-[#5C3D2E] hover:text-[#2A1408] mb-3"
                data-testid="btn-back-to-inbox"
            >
                <ArrowLeft size={16} />
                Retour aux messages
            </Link>
            <p className="section-tag">administration</p>
            <h1 className="font-serif-display text-4xl text-[#2A1408] tracking-tight">
                Messages traités <span className="text-base text-[#B07B66]">({items.length})</span>
            </h1>
            <p className="text-[#5C3D2E] mt-2 text-sm">
                Archives des demandes traitées. Vous pouvez les rouvrir ou les
                supprimer définitivement.
            </p>

            <div className="mt-6 space-y-3">
                <Paginated
                    items={items}
                    page={page}
                    setPage={setPage}
                    emptyText="Aucun message traité."
                    muted
                    actions={[
                        { label: "Rouvrir (en préparation)", to: "en_preparation", color: "amber" },
                    ]}
                    onSetStatus={setStatus}
                    onRemove={remove}
                />
            </div>
        </div>
    );
}
